import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useParams } from 'react-router-dom'
import { trocaHorario } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirTrocaDiaTrabalho() {
    const { id } = useParams<{ id: string }>()

    const { mutateAsync, isLoading } =
        trocaHorario.diaTrabalho.mutations.useDelete({
            invalidateQuery: true,
            onSuccess: () => {
                toast.success('Troca excluída com sucesso')
            },
            onError: (err: any) => {
                toast.error(err.message)
            },
        })

    async function handleSubmit() {
        if (!id) return
        return mutateAsync(Number(id))
    }

    return (
        <Dialog.Root
            height="auto"
            width="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'TrocaDeDiaDeTrabalho'])}
        >
            <Dialog.Content>
                Deseja excluir a troca de dia de trabalho?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error" closeOnSubmit>
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
